import React, { useState } from "react";
import {
  Form,
  Input,
  Row,
  Col,
  Spin,
  DatePicker,
  Radio,
  Select,
  ConfigProvider,
  message,
} from "antd";
import axios from "axios";
import moment from "moment";
import statesData from "../../data/states.json";
import regionsData from "../../data/regions.json";
import Navbar from "../../components/Navbar";

const { Option } = Select;

const Register = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const dateFormat = "YYYY-MM-DD";
  const customFormat = (value) => `${value.format(dateFormat)}`;
  const disabledDate = (current) => current && current.valueOf() > moment();

  const [name, setName] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [mobile, setMobile] = useState("");
  const [emailId, setEmailId] = useState("");
  const [dob, setDob] = useState(null);
  const [aadharNumber, setAadharNumber] = useState("");
  const [address, setAddress] = useState("");
  const [district, setDistrict] = useState("");
  const [taluka, setTaluka] = useState("");
  const [village, setVillage] = useState("");
  const [requirement, setRequirement] = useState("");
  const [typeOfBusiness, setTypeOfBusiness] = useState("");
  const [spinLoading, setSpinLoading] = useState(false);
  const [talukaKey, setTalukaKey] = useState(null);
  const [selectVisible, setSelectVisible] = useState(true);

  const districts = regionsData
    .flatMap((region) => region.districts)
    .map((district, index) => ({
      index,
      district_name: district.district_name,
      talukas: district.talukas,
    }));

  const checkDate = (date) => {
    console.log("checkDate called with:", date);
    if (!date) {
      messageApi.warning("Please select a valid date of birth");
      return;
    }
    const birthDate = new Date(date);
    const today = new Date();
    const ageInYears = (today - birthDate) / (1000 * 60 * 60 * 24 * 365);
    if (Math.floor(ageInYears) < 18) {
      messageApi.warning("Age should be 18 years or more");
    } else {
      setDob(date);
    }
  };

  const isPasswordValid = (password) => {
    const minLength = 8;
    const hasUppercase = /[A-Z]/.test(password);
    const hasLowercase = /[a-z]/.test(password);
    const hasDigit = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]/.test(password);
    return (
      password.length >= minLength &&
      hasUppercase &&
      hasLowercase &&
      hasDigit &&
      hasSpecialChar
    );
  };

  const handleRegisterSubmit = () => {
    if (name === "") {
      messageApi.warning("Name is empty");
    } else if (username === "") {
      messageApi.warning("Username is empty");
    } else if (mobile === "") {
      messageApi.warning("Mobile Number is empty");
    } else if (mobile.length !== 10) {
      messageApi.warning("Mobile Number must be 10 digits");
    } else if (emailId === "") {
      messageApi.warning("Email Id is empty");
    } else if (!dob) {
      messageApi.warning("Date of Birth is empty");
    } else if (aadharNumber === "") {
      messageApi.warning("Aadhar Number is empty");
    } else if (aadharNumber.length !== 12) {
      messageApi.warning("Aadhar Number must be 12 digits");
    } else if (address === "") {
      messageApi.warning("Address is empty");
    } else if (district === "") {
      messageApi.warning("District is empty");
    } else if (taluka === "") {
      messageApi.warning("Taluka is empty");
    } else if (requirement === "") {
      messageApi.warning("Primary Requirement is empty");
    } else if (password === "") {
      messageApi.warning("Password is empty");
    } else if (confirmPassword === "") {
      messageApi.warning("Confirm password is empty");
    } else if (password !== confirmPassword) {
      messageApi.warning("Passwords do not match");
    } else if (!isPasswordValid(password)) {
      messageApi.warning("Password does not meet the required policy");
    } else {
      setSpinLoading(true);
      const registerData = new FormData();
      registerData.append("name", name);
      registerData.append("username", username);
      registerData.append("password", password);
      registerData.append("phoneNumber", mobile);
      registerData.append("emailId", emailId);
      registerData.append("address", address);
      registerData.append("dob", dob);
      registerData.append("aadharNumber", aadharNumber);
      registerData.append("state", "Maharashtra");
      registerData.append("district", district);
      registerData.append("taluka", taluka);
      registerData.append("village", village);
      registerData.append("primaryRequirement", requirement);
      registerData.append("typeOfBusiness", typeOfBusiness);
      registerData.append("CasteName", "");
      registerData.append("SubCasteName", "");

      axios({
        method: "post",
        url: "https://bhugolapps.com/applicant/useregister",
        data: registerData,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((response) => {
          console.log("API response:", response.data);
          const userRegister = response.data;
          setSpinLoading(false);
          if (userRegister.status === "success") {
            messageApi.success(
              "You have successfully registered. Redirecting to login page..."
            );
            setTimeout(() => {
              window.location.href = "https://www.nbrmahapreit.in/login";
            }, 2000);
          } else {
            const errorMessage =
              userRegister.message ||
              userRegister.error ||
              "Registration failed. Please try again.";
            messageApi.warning(errorMessage);
          }
        })
        .catch((error) => {
          console.error(
            "API error:",
            error.response ? error.response.data : error.message
          );
          setSpinLoading(false);
          const errorMessage =
            error.response?.data?.message ||
            error.response?.data?.error ||
            "Registration failed due to a network or server error. Please try again.";
          messageApi.error(errorMessage);
        });
    }
  };

  return (
    <ConfigProvider>
      {contextHolder}
      <Spin spinning={spinLoading} tip="Registering...">
        <Navbar/>
        <div className="min-h-screen bg-gray-50 flex justify-center items-center py-12 px-4 sm:px-6 lg:px-8">
          <div className="w-full max-w-3xl bg-white rounded-xl shadow-xl p-10">
            <Form layout="vertical">
              <h1 className="text-4xl font-semibold text-center mb-10 text-gray-900">
                HKS Registration
              </h1>
              <Row gutter={[24, 16]}>
                <Col xs={24} md={12}>
                  <Form.Item
                    label={
                      <span className="text-base font-medium">
                        Name as per Aadhar
                      </span>
                    }
                    required
                  >
                    <Input
                      className="w-full p-3 rounded-md border-gray-300"
                      placeholder="Enter your Name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    label={
                      <span className="text-base font-medium">Username</span>
                    }
                    required
                  >
                    <Input
                      className="w-full p-3 rounded-md border-gray-300"
                      placeholder="Enter your Username"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      pattern="[a-zA-Z0-9]+"
                      title="Username must contain only letters and numbers."
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[24, 16]}>
                <Col xs={24} md={12}>
                  <Form.Item
                    label={
                      <span className="text-base font-medium">
                        Mobile no. as per Aadhar
                      </span>
                    }
                    required
                  >
                    <Input
                      className="w-full p-3 rounded-md border-gray-300"
                      placeholder="Enter your Mobile No"
                      type="tel"
                      value={mobile}
                      onChange={(e) => setMobile(e.target.value)}
                      maxLength={10}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    label={
                      <span className="text-base font-medium">Email Id</span>
                    }
                    required
                  >
                    <Input
                      className="w-full p-3 rounded-md border-gray-300"
                      placeholder="Enter your emailId"
                      value={emailId}
                      onChange={(e) => setEmailId(e.target.value)}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[24, 16]}>
                <Col xs={24} md={12}>
                  <Form.Item
                    label={
                      <span className="text-base font-medium">
                        Date of Birth
                      </span>
                    }
                    required
                  >
                    <DatePicker
                      className="w-full p-3 rounded-md border-gray-300"
                      format={customFormat}
                      value={dob ? moment(dob) : null}
                      onChange={(date, dateString) => checkDate(dateString)}
                      disabledDate={disabledDate}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    label={
                      <span className="text-base font-medium">
                        Aadhar Number
                      </span>
                    }
                    required
                  >
                    <Input
                      className="w-full p-3 rounded-md border-gray-300"
                      placeholder="Enter your Aadhar number"
                      type="tel"
                      maxLength={12}
                      value={aadharNumber}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          setAadharNumber(value);
                          console.log("Aadhar Number updated:", value);
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[24, 16]}>
                <Col xs={24} md={12}>
                  <Form.Item
                    label={
                      <span className="text-base font-medium">Address</span>
                    }
                    required
                  >
                    <Input.TextArea
                      className="w-full p-3 rounded-md border-gray-300"
                      placeholder="Enter your address as per aadhar"
                      value={address}
                      onChange={(e) => {
                        setAddress(e.target.value);
                        console.log("Address updated:", e.target.value);
                      }}
                      rows={4}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    label={
                      <span className="text-base font-medium">District</span>
                    }
                    required
                  >
                    <Select
                      showSearch
                      className="w-full"
                      placeholder="Select district"
                      value={district}
                      onChange={(value, option) => {
                        setDistrict(value);
                        setTalukaKey(option.key);
                        setTaluka("");
                        setSelectVisible(false);
                      }}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {districts.map((dist) => (
                        <Option key={dist.index} value={dist.district_name}>
                          {dist.district_name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[24, 16]}>
                <Col xs={24} md={12}>
                  <Form.Item
                    label={
                      <span className="text-base font-medium">Taluka</span>
                    }
                    required
                  >
                    <Select
                      showSearch
                      className="w-full"
                      placeholder="Select taluka"
                      value={taluka}
                      onChange={(value) => setTaluka(value)}
                      disabled={selectVisible}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {talukaKey !== null &&
                        districts[talukaKey]?.talukas.map((tal) => (
                          <Option key={tal.taluka_name} value={tal.taluka_name}>
                            {tal.taluka_name}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    label={<span className="text-base font-medium">State</span>}
                    required
                  >
                    <Select className="w-full" value="Maharashtra" disabled>
                      {statesData.map((state) => (
                        <Option key={state.key} value={state.name}>
                          {state.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[24, 16]}>
                <Col xs={24} md={12}>
                  <Form.Item
                    label={
                      <span className="text-base font-medium">Village</span>
                    }
                  >
                    <Input
                      className="w-full p-3 rounded-md border-gray-300"
                      placeholder="Enter your Village"
                      value={village}
                      onChange={(e) => setVillage(e.target.value)}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    label={
                      <span className="text-base font-medium">
                        Primary Requirement
                      </span>
                    }
                    required
                  >
                    <Radio.Group
                      value={requirement}
                      onChange={(e) => setRequirement(e.target.value)}
                      className="flex flex-wrap gap-4"
                    >
                      <Radio value="job" className="text-base">
                        Job
                      </Radio>
                      <Radio value="business" className="text-base">
                        Business
                      </Radio>
                      <Radio value="training" className="text-base">
                        Training
                      </Radio>
                      <Radio value="loan" className="text-base">
                        Loan
                      </Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
              {requirement === "business" && (
                <Row gutter={[24, 16]}>
                  <Col xs={24} md={12}>
                    <Form.Item
                      label={
                        <span className="text-base font-medium">
                          Type of Business
                        </span>
                      }
                      required
                    >
                      <Select
                        className="w-full"
                        value={typeOfBusiness}
                        onChange={(v) => setTypeOfBusiness(v)}
                      >
                        <Option value="native district">Native District</Option>
                        <Option value="whole of maharashtra">
                          Whole of Maharashtra
                        </Option>
                        <Option value="outside maharashtra">
                          Outside Maharashtra
                        </Option>
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              )}
              <Row gutter={[24, 16]}>
                <Col xs={24} md={12}>
                  <Form.Item
                    label={
                      <span className="text-base font-medium">
                        Create Password
                      </span>
                    }
                    required
                  >
                    <Input.Password
                      className="w-full p-3 rounded-md border-gray-300"
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    label={
                      <span className="text-base font-medium">
                        Confirm Password
                      </span>
                    }
                    required
                  >
                    <Input.Password
                      className="w-full p-3 rounded-md border-gray-300"
                      placeholder="Confirm your password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <div className="text-gray-600 mt-6 mb-8">
                    <span className="text-base font-medium">
                      Password Policy:
                    </span>
                    <ul className="list-disc pl-6 mt-2 text-sm">
                      <li>Minimum length: 8 characters</li>
                      <li>At least one uppercase letter</li>
                      <li>At least one lowercase letter</li>
                      <li>At least one digit</li>
                      <li>At least one special character</li>
                    </ul>
                  </div>
                </Col>
              </Row>
              <Form.Item>
                <button
                  type="button"
                  className="w-auto h-auto p-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition duration-300 text-lg font-medium"
                  style={{background:"#193367"}}
                  onClick={handleRegisterSubmit}
                >
                  Register
                </button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </Spin>
    </ConfigProvider>
  );
};

export default Register;
